
import AppointmentContainer from '../container/AppointmentContainer';
import DashboardContainer from '../container/DashboardContainer';
import BillContainer from '../container/BillContainer';
import Patients from '../components/Patients/Patients';
import ViewPrescription from '../components/Patients/ViewPrescription/ViewPrescription';
import PatientContainer from '../container/PatientContainer';
import StaffContainer from '../container/StaffContainer';
import ClinicsContainer from '../container/ClinicsContainer';
import TaskContainer from '../container/TaskContainer';
import ReviewContainer from '../container/ReviewContainer';

export default [
  {
    title: 'dashboard',
    component: DashboardContainer,
    url: '/:clinicId/:doctorId/dashboard',
    exact: true,
    auth: false,
    permission: 'dashboard',
  },
  {
    title: 'appointment',
    component: AppointmentContainer,
    url: '/:clinicId/:doctorId/appointment',
    exact: true,
    auth: false,
    permission: 'appointment',
  },
  {
    title: 'patient',
    component: PatientContainer,
    url: '/:clinicId/:doctorId/patients',
    exact: true,
    auth: false,
    permission: 'patients',
  },
  {
    title: 'staff',
    component: StaffContainer,
    url: '/:clinicId/:doctorId/staff',
    exact: true,
    auth: false,
    permission: 'staff',
  },
  {
    title: 'clinic',
    component: ClinicsContainer,
    url: '/:clinicId/:doctorId/clinics',
    exact: true,
    auth: false,
    permission: 'clinic',
  },
  {
    title: 'Bill',
    component: BillContainer,
    url: '/:clinicId/:doctorId/billing',
    exact: true,
    auth: false,
    permission: 'billing',
  },

  {
    title: 'Patients',
    component: Patients,
    url: `/appointment/Patients/:appointmentId`,
    exact: true,
    auth: false,
    permission: 'appointment',
  },

  {
    title: 'tasks',
    component: TaskContainer,
    url: '/:clinicId/:doctorId/tasks',
    exact: true,
    auth: false,
    permission: 'tasks',
  },
  {
    title: 'reviews',
    component: ReviewContainer,
    url: '/:clinicId/:doctorId/reviews',
    exact: true,
    auth: false,
    permission: 'reviews',
  },

  {
    title: 'ViewPrescription',
    component: ViewPrescription,
    url: `/viewPrescription/:id`
  }
];

